export const FEATURE_FLAGS = [
  // not public features
  'NOLT',
  'ADYEN',
  'HHV2',
  'V2UPLOAD',
  'ANALYZER_V1_DISABLED',
  'CHAT_WIDGET',
  'POKERWIZ',
  'NODELOCK_V2',

  // banner flags
  'BANNER_ANALYZER',
  'BANNER_POKERWIZ_MATCHMAKING',
  'BANNER_POKERWIZ',
  'BOOTCAMP',
  'BOOTCAMP_SOLD_OUT',

  // custom reports
  'CR_REPORTS',

  // multiway solutions - 3way
  'SOL_3WAY',

  // old features - timetested - can be deleted

  // temporary flags
  'GMF_SURVEY', // survey
  'FORCED_MANUAL_UPGRADE',
  'ANALYZER_BBWL_ENABLED',

  // dev flags
  'GATESBTNS', // show payment paypal/stripe btns
  'TTEAM', // translations
  'UNLIMITEDFAIRPLAY', // fairplay
  'GMF_SHOW_HIDDEN', // show hidden gametypes/gameformats

  // Analyzer
  'ANALYZER_SIDEBAR',

  //Uploads
  'UPLOADS_V4_HEADER_NAVIGATION',
  'UPLOADS_EXPORT',

  // gto reports
  'HANDS_V4',
  'GTO_REP_BANNER',
  'GTO_REP',
  'GTO_REPORTS_FLOP',
  'GTO_REPORTS_TURN',
  'GTO_REPORTS_RIVER',
  'GTO_REPORTS_AGGREGATE',
] as const

export type FeatureFlag = (typeof FEATURE_FLAGS)[number]
